import { signOut } from "@firebase/auth";
import React, { useEffect, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { Route, Routes } from "react-router-dom";
import { useAuth, useSigninCheck } from "reactfire";
import Record from "./Record";
import SignInForm from "./SignInForm";
import SnowGlobe from "./SnowGlobe";
import Start from "./Start";

export interface RoutingProps {}

const defaultImage = "";

const Routing: React.FC<RoutingProps> = ({ children }) => {
	const { status, data: signinResult } = useSigninCheck();
	const auth = useAuth();

	if (!signinResult) {
		return null;
	}

	const { signedIn } = signinResult;

	if (!signedIn) {
		return <SignInForm />;
	}

	return (
		<>
			<header>
				<div className="auth-wrapper">
					<div className="avatar">
						<img src={signinResult.user.photoURL ?? defaultImage} alt={`Signed in as ${signinResult.user.displayName}`} />
					</div>
					<div className="signout">
						<Button
							onClick={() => {
								signOut(auth);
							}}
						>
							<div className="deco">Sign Out</div>
						</Button>
					</div>
				</div>
			</header>
			<Routes>
				<Route path="/:gameId" element={<Record />} />
				<Route path="/" element={<Start />} />
			</Routes>
		</>
	);
};

export default Routing;
